import { NgModule } from '@angular/core';
import { S999gS999m01Component } from './s999g-s999m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S999gS999m01Component]
})
export class S999gModule { }

